export default __webpack_public_path__ + "static/media/card1.5f2d0a93.png";